/**
 * 金额日志
 */
 import Layout from '../../pages/layout/Frame';

 const amountRouter = {
     path: "/amountList",
     component: Layout,
     meta: {title: '金额日志'},
     name: "amount_list",
     children: [
         {
             path: "/amountList/index",
             component: () => import('../../pages/amountList/index'),
             meta: {title: '金额日志',},
             name: 'amount_list',
         },
     ]
 };
 
 export default amountRouter
 